import { render, staticRenderFns } from "./settingShop.vue?vue&type=template&id=62bc2428&scoped=true"
import script from "./settingShop.vue?vue&type=script&lang=js"
export * from "./settingShop.vue?vue&type=script&lang=js"
import style0 from "./settingShop.vue?vue&type=style&index=0&id=62bc2428&prod&lang=scss&scoped=true"
import style1 from "./settingShop.vue?vue&type=style&index=1&id=62bc2428&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bc2428",
  null
  
)

export default component.exports